export default __webpack_public_path__ + "static/sadams-318416d2e189a0ba4619b6b70793e622.jpg";